export default "__VITE_ASSET__60b59eb0__"